import React, { useEffect, useRef } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useLocale } from 'hooks';

import { Button, Loader } from 'ui';
import { StepContainer } from '../stepContainer/StepContainer';
import { ErrorIcon } from '../icons';

import { ViewReportProps } from './ViewReport.types';
import { useStyles } from './ViewReport.styles';

export const StepViewReport = ({
  goToNextStep,
  isLoading = false,
  text,
  isError = false,
  onRetry = () => {},
}: ViewReportProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();
  const prevIsLoading = useRef<boolean>(false);
  const { goBack } = useHistory();

  useEffect(() => {
    if (prevIsLoading.current && !isLoading && !isError) {
      goToNextStep();
    }
    prevIsLoading.current = isLoading;
  }, [goToNextStep, isLoading, isError]);

  const displayErrorScreen = () => (
    <>
      <Grid item container className={classes.content}>
        <Grid item xs={12}>
          <ErrorIcon className={classes.errorIcon} />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.title}>{formatMessage({ id: 'common.error' })}</Typography>
        </Grid>
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={6}>
          <Button variant="outlined" color="primary" onClick={goBack}>
            {formatMessage({ id: 'common.back' })}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant="contained" color="error" onClick={onRetry}>
            {formatMessage({ id: 'common.try_again' })}
          </Button>
        </Grid>
      </Grid>
    </>
  );

  const displayLoadingScreen = () => (
    <Grid item className={classes.content}>
      <Loader text={text} />
    </Grid>
  );

  return (
    <StepContainer title={formatMessage({ id: 'issue_battery.raport.title' })}>
      <Grid container className={classes.container}>
        {isLoading && !isError && displayLoadingScreen()}
        {!isLoading && isError && displayErrorScreen()}
      </Grid>
    </StepContainer>
  );
};
